import React, { ReactNode } from "react";
import { Flex, Spin } from "antd";

interface CustomLoaderProps {
  children?: ReactNode; // Marked children as optional
}

const CustomLoader: React.FC<CustomLoaderProps> = ({ children }) => (
  <Flex
    gap="middle"
    vertical
    className="min-h-screen w-full flex justify-center items-center custom-loader"
  >
    <Spin>{children ?? null}</Spin> {/* If no children, render null */}
  </Flex>
);

export default CustomLoader;
